import { createAction } from 'redux-actions';
import * as actionType from './actionTypes';

const setUser = createAction(actionType.SET_USER);
const clearUser = createAction(actionType.CLEAR_USER);
const setUserOption = createAction(actionType.SET_USER_OPTION);

export { setUser, clearUser, setUserOption };
